import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import TableDescriptors from '../../../definitions/tableDescriptors';
import EntityTable from '../../components/common/entity/entityTable';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import RulesFormPopup from '../../components/calendarAdmin/ruleFormPopup';

/* Actions */
import * as calendarAdminActions from '../../actions/calendarAdmin/index';

/*Components*/
import GlassPopup from '../../components/common/interface/glassPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import Button from '../../components/common/inputs/button';
import CalendarFormPopup from '../../components/calendarAdmin/calendarFormPopup';

import {Calendar} from 'react-calendar';
import Spinner from '../../components/common/interface/spinner';
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';

const popupIds = {
  calendarFormPopup: "calendarFormPopup",
  rulesFormPopup: "rulesFormPopup",
  deleteCalendarConfirmPopup: "deleteCalendarConfirmPopup",
  deleteRuleConfirmPopup: "deleteRuleConfirmPopup",  
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class CalendarPopupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: null,
      selectedName: null,
      calendarLoading: false,
      initialNewCalendarEntity: { default: false },
      initialNewRuleEntity: {
        repetition: Constants.selectKeys.calendar.repetitionOptions.WEEKS,
        repeat_every: 1,
        laboral: false,
        override_holidays: false,
        is_general_rule: false,
        rule_hash: {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
        },
      },
      calendarKey: 0,
      activeStartDate: new Date(),
      formHasChanges: false,
    };
  }
 
  componentDidMount() {
    this.props.actions.getCalendarsList()
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    //save calendar feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.save.status],
      [this.props.save.status],
      intl.formatMessage({ id: "calendarAdmin.saveCalendarSuccess" }),
      null,
      [() => {
        this.setState({ formHasChanges: false });
        // this.handleShowCalendarFormPopup();
        InterfaceTooling.popupHide(popupIds.calendarFormPopup, this.setState.bind(this));
        this.props.actions.getCalendarsList();
      }]      
    );

    //delete calendar feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteCalendar.status],
      [this.props.deleteCalendar.status],
      intl.formatMessage({ id: "calendarAdmin.deleteCalendarSuccess" }),
      this.props.deleteCalendar.status!=422 ? 
        intl.formatMessage({ id: "calendarAdmin.deleteCalendarFailure" }) : 
        intl.formatMessage({ id: "calendarAdmin.deleteCalendarErrorRulesExist"}),
      [() => {
        this.handleDeleteCalendarPopup();
        this.props.actions.getCalendarsList();
        if(this.props.deleteCalendar.id == this.state.selectedId) {
          this.setState({
            selectedId: null,
            selectedName: null
          });
        }
      }]
    );
    
    //save rule feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.saveRule.status],
      [this.props.saveRule.status],
      intl.formatMessage({ id: "calendarAdmin.saveRuleSuccess" }),
      null,
      [() => {
        this.setState({ formHasChanges: false });
        // this.handleShowRulesFormPopup()
        InterfaceTooling.popupHide(popupIds.rulesFormPopup, this.setState.bind(this));
        this.props.actions.getRulesList(this.state.selectedId)
        this.handleOnCalendarMonthChange({activeStartDate: this.state.activeStartDate})
      }]
    );

    //delete rule feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteRule.status],
      [this.props.deleteRule.status],
      intl.formatMessage({ id: "calendarAdmin.deleteRuleSuccess" }),
      intl.formatMessage({ id: "calendarAdmin.deleteRuleFailure" }),
      [() => {
        this.handleDeleteRulePopup();
        this.props.actions.getRulesList(this.state.selectedId);
        this.handleOnCalendarMonthChange({activeStartDate: this.state.activeStartDate});
      }]
    );
  }

  setCalendarDayClassName = ({ activeStartDate, date, view }) => {
    if(this.props.calendarLaboralDays.data){
      if(this.props.calendarLaboralDays.data[date.getDate()-1]){     
        return this.props.calendarLaboralDays.data[date.getDate()-1].is_laboral ? 'flex_calendar_tile_active' : 'flex_calendar_tile_inactive'
      } 
    }
    else{
      return "flex_calendar_tile_inactive"
    }
  }

  handleOnChangeCalendarForm = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.props.actions.setSaveCalendarEntityDataByKey(event.currentTarget.dataset.path, value);
    this.setState({ formHasChanges: true });
  }

  handleOnChangeRulesCalendarForm = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.props.actions.setSaveRuleEntityDataByKey(event.currentTarget.dataset.path, value);    
    this.setState({ formHasChanges: true });
  }

  handleOnSaveCalendarForm = (event) => {
    this.props.actions.saveCalendarEntity(this.props.save.data);
  }

  handleOnSaveRuleForm = (event) => {
    let dataToSend =  JavascriptUtilsTooling.deepCopy(this.props.saveRule.data);
    if(!dataToSend.calendar_id){
      dataToSend.calendar_id = this.state.selectedId
    }
    this.props.actions.saveRuleEntity(dataToSend);
  }

  handleOnCalendarMonthChange = ({action, activeStartDate, value, view }) => {
    if(action && action!="next" && action!="prev") {
      return;
    }
    if(!activeStartDate){
      var activeStartDate = new Date()
    }

    let daysInMonth = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth()+1, 0).getDate()
    let startDate = `${activeStartDate.getFullYear()}/${activeStartDate.getMonth()+1}/1`
    let endDate = `${activeStartDate.getFullYear()}/${activeStartDate.getMonth()+1}/${daysInMonth}`

    if(this.state.selectedId){
      this.props.actions.getCalendarLaboralDays({
        start_date: startDate,
        end_date: endDate,
        calendar_id: this.state.selectedId
      })
    }
    this.setState({
      activeStartDate: activeStartDate
    });
  }

  handleCalendarRowClick = (event) => {
    let calendar = JSON.parse(event.currentTarget.dataset.entitydata);
    this.setState({
      selectedId: calendar.id,
      selectedName: calendar.name,
      calendarLoading: true
    }, async () => {
      await this.props.actions.getRulesList(this.state.selectedId);
      await this.handleOnCalendarMonthChange({activeStartDate: this.state.activeStartDate});
      this.setState({
        calendarLoading: false
      });
    })
  };
  
  handleCloseCalendarAdminForm = async(event) => {
    InterfaceTooling.popupHide(popupIds.closeFormConfirmPopup, this.setState.bind(this));
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.calendarFormPopup])) {
      InterfaceTooling.popupHide(popupIds.calendarFormPopup, this.setState.bind(this));
    }
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.rulesFormPopup])) {
      InterfaceTooling.popupHide(popupIds.rulesFormPopup, this.setState.bind(this));
    }   

    this.setState({
      formHasChanges: false,
    })
  }

  handleCalendarAdminShowFormPopupWithConfirmOnExit = (event, popupId, state, setState, loading = false, callbackOnOpen = null, popupIdConfirmClose="closeFormConfirmPopup") => {
    if(event) {
      event.preventDefault();
    };    
    if(loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(state[popupId])) {
      if(callbackOnOpen) {
        callbackOnOpen();
      }
      InterfaceTooling.popupShow(popupId, setState);
    }
    else {
      if(((popupId == "calendarFormPopup") || (popupId == "rulesFormPopup")) && (state.formHasChanges!=null) && state.formHasChanges){        
        InterfaceTooling.handleShowPopup(event, popupIdConfirmClose, state, setState, loading);
      }
      else{
        InterfaceTooling.popupHide(popupId, setState);
      }
    }
  }

  handleShowCalendarFormPopup = event => {
    if(event) {
      event.stopPropagation();
    }
    this.handleCalendarAdminShowFormPopupWithConfirmOnExit(
      event, popupIds.calendarFormPopup, this.state, 
      this.setState.bind(this), this.props.save.loading, () => {
        let entityObject = {};        
        if(event.currentTarget.dataset.entitydata) {
          entityObject["calendar"] = JSON.parse(event.currentTarget.dataset.entitydata)
          this.props.actions.resetSaveCalendarEntity(entityObject);
        }
        else {
          entityObject = {"calendar": this.state.initialNewCalendarEntity};
          this.props.actions.resetSaveCalendarEntity(entityObject);
        }                
        this.setState({ formHasChanges: false });    
      }
    );
  }

  handleShowRulesFormPopup = event => {
    this.handleCalendarAdminShowFormPopupWithConfirmOnExit(
      event, popupIds.rulesFormPopup, this.state, 
      this.setState.bind(this), this.props.saveRule.loading, () => {  
        let entityObject = {};        
        if(event.currentTarget.dataset.entitydata) {
          entityObject["calendar_rule"] = JSON.parse(event.currentTarget.dataset.entitydata)
          this.props.actions.resetSaveRulesCalendarEntity(entityObject);
        }
        else {
          entityObject = {"calendar_rule": this.state.initialNewRuleEntity};
          this.props.actions.resetSaveRulesCalendarEntity(entityObject);
        }        
        this.setState({ formHasChanges: false });     
      }
    );
  }

  handleDeleteCalendarPopup = (event, calendar) => {    
    if(event) {
      event.stopPropagation();
    }
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteCalendarConfirmPopup, this.state, 
      this.setState.bind(this), this.props.deleteCalendar.loading, () => {
        if(event.currentTarget.dataset.entitydata) {
          let calendar = JSON.parse(event.currentTarget.dataset.entitydata);
          this.props.actions.prepareDeleteCalendarEntity(calendar.id);
        }
      }
    );
  }

  handleDeleteCalendarConfirm = (event) => {
    this.props.actions.deleteCalendarEntity({id: this.props.deleteCalendar.id});
  }

  handleDeleteRulePopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteRuleConfirmPopup, this.state, 
      this.setState.bind(this), this.props.deleteRule.loading, () => {   
        if(event.currentTarget.dataset.entitydata){
          let calendar_rule = JSON.parse(event.currentTarget.dataset.entitydata);
          this.props.actions.prepareDeleteRuleEntity(calendar_rule.id);
        }    
      }
    );
  }

  handleDeleteRuleConfirm = (event) => {
    this.props.actions.deleteRuleEntity({id: this.props.deleteRule.id});
  }
  
  calendarLabelFunction = ({date, label, locale, view}) => {
    let options_month = {month: 'long',}
    let options_year = {year: 'numeric',}
    return `${date.toLocaleDateString(locale, options_month)}, ${date.toLocaleDateString(locale, options_year)}`
  }
  
  handleCalendarClickDay = (clickedDay) => {
    let dateClickedFormated = FormatTooling.zeroPadding(clickedDay.getDate(),2) + "/" + FormatTooling.zeroPadding((clickedDay.getMonth()+1),2) + "/" + clickedDay.getFullYear()
    if(clickedDay.getMonth()!=this.state.activeStartDate.getMonth()) {
      return;
    }
    InterfaceTooling.handleShowPopup(
      event, popupIds.rulesFormPopup, this.state, 
      this.setState.bind(this), this.props.saveRule.loading, () => {  
        let entityObject = {};        
        entityObject = {"calendar_rule": JavascriptUtilsTooling.deepCopy(this.state.initialNewRuleEntity)};
        entityObject.calendar_rule.repetition = Constants.selectKeys.calendar.repetitionOptions.YEARS;
        entityObject.calendar_rule.start_date = dateClickedFormated;
        entityObject.calendar_rule.repeat_times = 0;
        entityObject.calendar_rule.override_holidays = true;
        entityObject.calendar_rule.priority = this.props.rulesList.data.reduce(
          (prevPriority, rule) => (rule.priority>=prevPriority ? rule.priority+1 : prevPriority),
          0
        );
        entityObject.calendar_rule.laboral = this.props.calendarLaboralDays.data.reduce(
          (prevIsLaboral, day) => (day.day == dateClickedFormated ? !day.is_laboral : prevIsLaboral),
          false
        );
        this.props.actions.resetSaveRulesCalendarEntity(entityObject);
      }
    );
  }

  render() {
    let calendarsTableActions = [this.handleShowCalendarFormPopup, this.handleDeleteCalendarPopup]
    let calendarsTableActionsTooltips = [intl.formatMessage({ id: "calendarAdmin.calendarTooltipEdit"}), intl.formatMessage({ id: "calendarAdmin.calendarTooltipDelete"})]

    let rulesTableActions = [this.handleShowRulesFormPopup, this.handleDeleteRulePopup]
    let rulesTableActionsTooltips = [intl.formatMessage({ id: "calendarAdmin.ruleTooltipEdit"}), intl.formatMessage({ id: "calendarAdmin.ruleTooltipDelete"})]

    let tableActionsIcons = ["fas fa-edit", "fas fa-trash"]

    return (
      <div className="calendar_admin_container">
        <GlassPopup
          className="form_popup calendar_popup"
          title={(<FormattedMessage id="calendarAdmin.title"/>)}
          handleShowPopup={this.props.handleShowPopup}
          popupState={this.props.popupState}          
          fullLoading={this.props.calendarList.loading || this.props.rulesList.loading || this.state.calendarLoading}
        >
          <div className="row_fields">
            <div className="calendar_list_column calendar_column_left">
              <EntityTable
                entityTableDescriptor={TableDescriptors.calendarList}
                data={this.props.calendarList.data}
                selectedId={this.state.selectedId}
                handleCustomActions={calendarsTableActions}
                customActionsIcons={tableActionsIcons}
                customActionsTooltips={calendarsTableActionsTooltips}
                handleRowClick={this.handleCalendarRowClick}
                className="assign_table_component"
              />
              <Button
                onClick={this.handleShowCalendarFormPopup}
                labelLocale={intl.formatMessage({ id: "calendarAdmin.createCalendarButton"})}
                className="create_calendar_button"
              />
            </div>
            {(this.state.selectedId && !this.state.calendarLoading) &&
              <div className="calendar_list_column calendar_column_right">
                <EntityTable
                  entityTableDescriptor={TableDescriptors.rulesList}
                  data={this.props.rulesList.data}
                  handleCustomActions={rulesTableActions}
                  customActionsIcons={tableActionsIcons}
                  customActionsTooltips={rulesTableActionsTooltips}
                  className="create_rule_button"
                />
                <Button
                  disabled={!this.state.selectedId}
                  onClick={this.handleShowRulesFormPopup}
                  labelLocale={intl.formatMessage({ id: "calendarAdmin.createRuleButton"})}
                />
              </div>
            }
            {(this.state.selectedId && !this.props.calendarLaboralDays.loading && !this.props.rulesList.loading && !this.state.calendarLoading) &&     
              <div className="calendar_column">                  
                <Calendar
                  activeStartDate={this.state.activeStartDate}
                  navigationLabel={this.calendarLabelFunction}
                  tileClassName={this.setCalendarDayClassName}
                  minDetail="month"
                  prevLabel={(!this.props.calendarLaboralDays.loading) && <i className="fas fa-angle-left" aria-hidden="true" />}
                  // prev2Label={(!this.props.calendarLaboralDays.loading) && <i className="fas fa-angle-double-left" aria-hidden="true" />}
                  // next2Label={(!this.props.calendarLaboralDays.loading) && <i className="fas fa-angle-double-right" aria-hidden="true" />}
                  prev2Lavel={""}
                  next2Lavel={""}
                  nextLabel={(!this.props.calendarLaboralDays.loading) && <i className="fas fa-angle-right" aria-hidden="true" />}
                  onActiveStartDateChange={this.handleOnCalendarMonthChange}
                  onClickDay={this.handleCalendarClickDay}
                />
                <div className="calendar_leyend">
                  <div className="row_fields laboral_days">
                    <div className="calendar_leyend_color"></div>
                    <div className="calendar_leyend_text">
                      <FormattedMessage id="calendarAdmin.laboralDayLeyend"/>
                    </div>
                  </div>
                  <div className="row_fields non_laboral_days">
                    <div className="calendar_leyend_color"></div>
                    <div className="calendar_leyend_text">
                      <FormattedMessage id="calendarAdmin.nonLaboralDayLeyend"/>
                    </div>
                  </div>
                </div>
                <p className="calendar_preview_label">
                  {intl.formatMessage({ id: "calendarAdmin.calendarPreviewLabel"}) + ": " + this.state.selectedName}
                </p>
                <p className="calendar_return_today_label" onClick={this.handleOnCalendarMonthChange}>
                  {intl.formatMessage({ id: "calendarAdmin.returnToActualMonthLabel"})}
                </p>
              </div>
            }
            {!this.state.selectedId &&     
              <div className="calendar_column no_calendar_selected_wrapper">
                {intl.formatMessage({ id: "calendarAdmin.noSelectedCalendarPreviewText"})}
              </div>
            }
            {(this.props.calendarLaboralDays.loading && !this.props.rulesList.loading && !this.state.calendarLoading) &&
              <div className="calendar_column">
                <Spinner/>
              </div>
            }
          </div>
        </GlassPopup>
        <CalendarFormPopup
          handleShowPopup={this.handleShowCalendarFormPopup}
          handleOnChangeForm={this.handleOnChangeCalendarForm}
          handleButton={this.handleOnSaveCalendarForm}
          loadingButton={this.props.save.loading}
          formData={this.props.save.data}
          statusButton={this.props.save.status}
          errors={this.props.save.errors}
          entityNameSingular={TableDescriptors.calendarList.entityNameSingular}
          popupState={this.state[popupIds.calendarFormPopup]}
        />
        <RulesFormPopup
          handleShowPopup={this.handleShowRulesFormPopup}
          handleOnChangeForm={this.handleOnChangeRulesCalendarForm}
          handleButton={this.handleOnSaveRuleForm}
          loadingButton={this.props.saveRule.loading}
          statusButton={this.props.saveRule.status}
          errors={this.props.saveRule.errors}
          formData={this.props.saveRule.data}
          entityNameSingular={TableDescriptors.rulesList.entityNameSingular}
          popupState={this.state[popupIds.rulesFormPopup]}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage 
            id={"common.entity.deleteEntityConfirmTitle"}
            values={{entityNameSingular: (<FormattedMessage id={"calendarAdmin.entityNameSingular"}/>)}}
          />)}
          confirmText={(<FormattedMessage 
            id={"common.entity.deleteEntityConfirm"}
            values={{entityNameSingular: (<FormattedMessage id={"calendarAdmin.entityNameSingularWithArticle"}/>)}}
          />)}
          handleConfirm={this.handleDeleteCalendarConfirm}
          handleCancel={this.handleDeleteCalendarPopup}
          popupState={this.state[popupIds.deleteCalendarConfirmPopup]}
          loading={this.props.deleteCalendar.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage 
            id={"common.entity.deleteEntityConfirmTitle"}
            values={{entityNameSingular: (<FormattedMessage id={"calendarAdmin.ruleEntityNameSingular"}/>)}}
          />)}
          confirmText={(<FormattedMessage 
            id={"common.entity.deleteEntityConfirm"}
            values={{entityNameSingular: (<FormattedMessage id={"calendarAdmin.ruleEntityNameSingularWithArticle"}/>)}}
          />)}
          handleConfirm={this.handleDeleteRuleConfirm}
          handleCancel={this.handleDeleteRulePopup}
          popupState={this.state[popupIds.deleteRuleConfirmPopup]}
          loading={this.props.deleteRule.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
          confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
          handleConfirm={this.handleCloseCalendarAdminForm}
          handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
          popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
          loading={false}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  calendarList: state.reducer.calendarAdmin.calendarList,
  rulesList: state.reducer.calendarAdmin.rulesList,
  calendarLaboralDays: state.reducer.calendarAdmin.calendarLaboralDays,
  save: state.reducer.calendarAdmin.save,
  deleteCalendar: state.reducer.calendarAdmin.deleteCalendar,
  saveRule: state.reducer.calendarAdmin.saveRule,
  deleteRule: state.reducer.calendarAdmin.deleteRule,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(calendarAdminActions, dispatch)
});

CalendarPopupContainer.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarPopupContainer);



// WEBPACK FOOTER //
// ./source/client/containers/calendarAdmin/calendarPopupContainer.jsx